import * as z from "zod";
import { threePlDateRangeInput } from "./three-pl-date-range-input";

const dailyItemsProcessedSchema = z.object({
  /** ISO date (YYYY-MM-DD) in the team's timezone. */
  date: z.string(),
  itemsProcessed: z.number(),
});

export const get3plDailyItemsProcessed = {
  name: "get3plDailyItemsProcessed" as const,
  input: threePlDateRangeInput,
  output: z.object({ days: z.array(dailyItemsProcessedSchema) }),
};

export type ThreePlDailyItemsProcessedOutput = z.infer<
  (typeof get3plDailyItemsProcessed)["output"]
>;
